import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ChekIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m13 4.5-6.875 7L3 8.318" /></svg>
  );
}

export default ChekIcon;
